import { render, staticRenderFns } from "./CancelEventSubmissionModal.vue?vue&type=template&id=901da2c4&scoped=true&lang=pug"
import script from "./CancelEventSubmissionModal.vue?vue&type=script&lang=js"
export * from "./CancelEventSubmissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901da2c4",
  null
  
)

export default component.exports